import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { colors } from '@global/constants'

export const Meta = styled.div`
  display: flex;

  & > section:last-of-type {
    border-right: none;
  }
`

export const MetaDetail = styled.section`
  display: flex;
  flex: 1;
  flex-direction: column;
  white-space: nowrap;
  z-index: 1;
`

export const MetaDetailSeparator = styled.section`
  border-left: 1px solid #e0e0e0;
  margin: 0 10px 0 13px;
  width: 1px;
  height: 14px;
`

export const MetaDetailLabel = styled.h1`
  margin: 0;
  font-size: 11px;
  color: ${colors.sonicSilver};
  line-height: 1.65;
`

export const MetaDetailValue = styled.h3`
  margin: 0;
  font-size: 14px;
  color: ${colors.brand.primary};
  overflow: hidden;
  text-overflow: ellipsis;
`

export const PopoverTitle = styled.div`
  padding: 6px 8px;
  margin: 0;
  width: 100%;
  font-size: 10px;
  color: #787878;
  border-top: 1px solid #d3d3d3;
`

export const PopoverStyles = css`
  .MuiPaper-root {
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
`

export const integrations = css`
  justify-content: flex-end;

  .MuiAvatar-root {
    padding: 1px;
    width: 14px;
    height: 14px;
    font-size: 1em;
    background: #fff;
  }
`

export const grayBg = css`
  div:first-of-type {
    background: #bdbdbd;
  }
`

export const hoverable = css`
  cursor: pointer;

  :hover {
    cursor: pointer;
  }
`
